import { FC } from 'react';
import styled from 'styled-components';

import { useAuthorization } from 'entities/user/hooks/useAuthorization';
import { MpLink } from 'shared/ui/MpLink';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpPropertyTitle } from 'shared/ui/MpPropertyTitle';
import { MpText } from 'shared/ui/MpText';
import { MpTitle } from 'shared/ui/MpTitle';
import { MpUl } from 'shared/ui/MpUl';

const DescriptionBlockStyled = styled.div`
	gap: 12px;
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
`;

const SubheadingStyled = styled(MpPropertyTitle)`
	margin-bottom: 0;
`;

const ListSubheadingStyled = styled.b`
	font-weight: 600;
`;

const SectionStyled = styled.section`
	margin-top: 32px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-top: 48px;
	}
`;

const RoadmapStyled = styled.div`
	gap: 16px;
	display: flex;
	flex-direction: column;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 24px;
	}
`;

const RoadmapItemStyled = styled.div`
	padding: 16px 24px;
	border-radius: 12px;
	background-color: #fafafa;
`;

export const KonsolDescription: FC = () => {
	const authorization = useAuthorization();
	const canPurchaseApps = authorization?.canPurchaseApps;

	return (
		<>
			<section>
				<MpParagraph style={{ marginBottom: `24px` }}>
					Интеграция Dodo IS и&nbsp;Konsol.pro предоставит возможность ежедневно выплачивать вознаграждения
					самозанятым. Это&nbsp;позволит уменьшить проблему с&nbsp;поиском исполнителей и&nbsp;повысит
					привлекательность сотрудничества с&nbsp;компанией для&nbsp;самозанятых.
				</MpParagraph>
				<DescriptionBlockStyled>
					<SubheadingStyled>Что доступно уже сейчас?</SubheadingStyled>
					<MpText style={{ marginBottom: `24px` }}>
						Первая версия интеграционного модуля&nbsp;— это&nbsp;полуручное решение с&nbsp;минимальными
						функциями для&nbsp;пиццерий, которые хотят организовать ежедневные выплаты вознаграждения новым
						самозанятым, которые оказывают услуги по&nbsp;доставке в&nbsp;пиковые дни&nbsp;праздников.
					</MpText>
					<MpText>Для&nbsp;корректной работы модуля необходимо:</MpText>
					<MpUl>
						<li>
							<MpText>Заполнить все&nbsp;данные исполнителя в&nbsp;Dodo IS, особенно&nbsp;ИНН.</MpText>
						</li>
						<li>
							<MpText>
								В&nbsp;Konsol.Pro: между&nbsp;исполнителем и&nbsp;Додо IS должен быть подписан договор.
								В&nbsp;личном кабинете исполнителя в&nbsp;Konsol.Pro должны быть заполнены
								все&nbsp;данные самозанятого.
							</MpText>
						</li>
					</MpUl>
				</DescriptionBlockStyled>
				<DescriptionBlockStyled>
					<SubheadingStyled>Преимущества интеграции:</SubheadingStyled>
					<MpUl>
						<li>
							<MpText>
								<ListSubheadingStyled>
									Еще&nbsp;один шаг&nbsp;в&nbsp;автоматизации процесса вознаграждений
								</ListSubheadingStyled>
								<br />
								Теперь можно автоматически создавать реестр вознаграждений в&nbsp;формате, который
								подходит для&nbsp;загрузки в&nbsp;Konsol.Pro.
							</MpText>
						</li>
						<li>
							<MpText>
								<ListSubheadingStyled>Дополнительная экономия времени</ListSubheadingStyled>
								<br />
								Решение позволяет быстро собрать информацию со&nbsp;всех юнитов юридического лица
								в&nbsp;единый документ.
							</MpText>
						</li>
						<li>
							<MpText>
								<ListSubheadingStyled>Гибкость вознаграждений исполнителям</ListSubheadingStyled>
								<br />
								Интеграция позволяет выплачивать вознаграждения день в&nbsp;день&nbsp;— ежедневно
								подписывают и&nbsp;ежедневно получают деньги. Или&nbsp;подписывать акты
								раз&nbsp;в&nbsp;неделю&nbsp;— получают деньги раз&nbsp;в&nbsp;неделю.
							</MpText>
						</li>
					</MpUl>
				</DescriptionBlockStyled>
				<DescriptionBlockStyled>
					<SubheadingStyled>Roadmap разработки интеграции</SubheadingStyled>
					<RoadmapStyled>
						<RoadmapItemStyled>
							<SubheadingStyled style={{ marginBottom: `12px` }}>Конец января — v 1.X</SubheadingStyled>
							<MpUl>
								<li>
									<MpText>
										Возможность разделять самозанятых, которые хотят получать вознаграждения
										раз&nbsp;в&nbsp;неделю и&nbsp;раз&nbsp;в&nbsp;день.
									</MpText>
								</li>
								<li>
									<MpText>Возможность исправления вероятности неверного ввода&nbsp;ИНН.</MpText>
								</li>
							</MpUl>
						</RoadmapItemStyled>
						<RoadmapItemStyled>
							<SubheadingStyled style={{ marginBottom: `12px` }}>
								Середина февраля — v 2.0
							</SubheadingStyled>
							<MpUl>
								<li>
									<MpText>
										Отказ от&nbsp;необходимости скачивания и&nbsp;загрузки XLS-реестра. Добавление
										интерактивной функции, которая позволяет увидеть и&nbsp;подтвердить суммы
										для&nbsp;оплаты.
									</MpText>
								</li>
								<li>
									<MpText>
										Выявление новых проблем после&nbsp;реального использования фичи и&nbsp;внесение
										их&nbsp;в&nbsp;roadmap.
									</MpText>
								</li>
							</MpUl>
						</RoadmapItemStyled>
						<RoadmapItemStyled>
							<SubheadingStyled style={{ marginBottom: `12px` }}>Конец февраля — v 2.X</SubheadingStyled>
							<MpUl>
								<li>
									<MpText>
										Оценка возможности предварительной настройки шаблонов и&nbsp;продукта
										автоматического начала работы.
									</MpText>
								</li>
								<li>
									<MpText>
										Выявление новых проблем после&nbsp;реального использования фичи и&nbsp;внесение
										их&nbsp;в&nbsp;roadmap.
									</MpText>
								</li>
							</MpUl>
						</RoadmapItemStyled>
					</RoadmapStyled>
				</DescriptionBlockStyled>
			</section>
			{canPurchaseApps && (
				<SectionStyled>
					<MpTitle level={2}>Стоимость комиссии</MpTitle>
					<MpText style={{ marginBottom: `12px` }}>
						Для&nbsp;партнеров сети «Додо Пицца» действуют персональные условия. Они&nbsp;могут меняться
						в&nbsp;зависимости от&nbsp;ваших оборотов. Больше вознаграждений самозанятым&nbsp;— меньше
						процент комиссии и&nbsp;лицензионный платеж.
					</MpText>
					<SubheadingStyled>
						Лицензионный платеж за&nbsp;подключение одного самозанятого в&nbsp;месяц к&nbsp;ЭДО:
					</SubheadingStyled>
					<MpUl>
						<li>
							<MpText>
								250&nbsp;₽ /&nbsp;мес. за&nbsp;каждого исполнителя, с&nbsp;которым был&nbsp;подписан
								минимум один документ, кроме договора.
							</MpText>
						</li>
					</MpUl>
					<SubheadingStyled>Процент комиссии от&nbsp;вознаграждения самозанятому:</SubheadingStyled>
					<MpUl style={{ gap: `unset` }}>
						<li>
							<MpText>
								1%, но&nbsp;не&nbsp;менее 49&nbsp;₽, от&nbsp;суммы вознаграждения исполнителю
								на&nbsp;расчетный счет.
							</MpText>
						</li>
						<li>
							<MpText>
								1%, но&nbsp;не&nbsp;менее 75&nbsp;₽, от&nbsp;суммы вознаграждения исполнителю
								по&nbsp;номеру карты.
							</MpText>
						</li>
					</MpUl>
					<MpText>
						Напишите нам&nbsp;на&nbsp;почту{` `}
						<MpLink url='mailto:dodo@konsol.pro' text='dodo@konsol.pro' internal />, чтобы&nbsp;узнать
						подробности и&nbsp;получить бесплатный демодоступ к&nbsp;платформе.
					</MpText>
				</SectionStyled>
			)}
		</>
	);
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const KonsolDescription_eng: FC = () => {
	const authorization = useAuthorization();
	const canPurchaseApps = authorization?.canPurchaseApps;

	return (
		<>
			<section>
				<MpParagraph style={{ marginBottom: `24px` }}>
					Integration of Dodo IS and Konsol.pro will allow pizzerias to make daily payments to couriers. This
					will reduce the problem of recruiting staff and increase company loyalty for applicants.
				</MpParagraph>
				<DescriptionBlockStyled>
					<SubheadingStyled>What&apos;s Available Now?</SubheadingStyled>
					<MpText style={{ marginBottom: `24px` }}>
						The first version of the integration module is a semi-automatic solution with minimal functions
						for pizzerias that want to organize daily payments to new couriers hired for peak days of the
						New Year holidays, including part-time work.
					</MpText>
					<MpText>To work correctly, the module requires:</MpText>
					<MpUl>
						<li>
							<MpText>Fill in all courier data in Dodo IS, especially the INN.</MpText>
						</li>
						<li>
							<MpText>
								In Konsol.Pro: a contract must be signed between the performer and Dodo IS. In the
								performer&apos;s personal account in Konsol.Pro, all courier data must be filled out.
							</MpText>
						</li>
					</MpUl>
				</DescriptionBlockStyled>
				<DescriptionBlockStyled>
					<SubheadingStyled>Integration Benefits:</SubheadingStyled>
					<MpUl>
						<li>
							<MpText>
								<ListSubheadingStyled>Another step in automating payments</ListSubheadingStyled>
								<br />
								Now it&apos;s possible to automatically create a payment register in a format suitable
								for loading into Konsol.Pro.
							</MpText>
						</li>
						<li>
							<MpText>
								<ListSubheadingStyled>Additional time savings</ListSubheadingStyled>
								<br />
								The solution allows quickly gathering information from all legal entity units into a
								single document.
							</MpText>
						</li>
						<li>
							<MpText>
								<ListSubheadingStyled>Flexibility in payments to performers</ListSubheadingStyled>
								<br />
								The integration allows making daily payments—signing and receiving money daily. Or
								signing acts once a week—receiving money once a week.
							</MpText>
						</li>
					</MpUl>
				</DescriptionBlockStyled>
				<DescriptionBlockStyled>
					<SubheadingStyled>Integration Development Roadmap</SubheadingStyled>
					<RoadmapStyled>
						<RoadmapItemStyled>
							<SubheadingStyled style={{ marginBottom: `12px` }}>End of January — v 1.X</SubheadingStyled>
							<MpUl>
								<li>
									<MpText>
										The ability to separate couriers who want to receive payment once a week and
										once a day.
									</MpText>
								</li>
								<li>
									<MpText>
										The ability to correct the likelihood of incorrect input of the INN.
									</MpText>
								</li>
							</MpUl>
						</RoadmapItemStyled>
						<RoadmapItemStyled>
							<SubheadingStyled style={{ marginBottom: `12px` }}>Mid-February — v 2.0</SubheadingStyled>
							<MpUl>
								<li>
									<MpText>
										Elimination of the need to download and upload the XLS register. Adding an
										interactive feature that allows you to see and confirm amounts for payment.
									</MpText>
								</li>
								<li>
									<MpText>
										Identifying new issues after real-world use of the feature and incorporating
										them into the roadmap.
									</MpText>
								</li>
							</MpUl>
						</RoadmapItemStyled>
						<RoadmapItemStyled>
							<SubheadingStyled style={{ marginBottom: `12px` }}>
								End of February — v 2.X
							</SubheadingStyled>
							<MpUl>
								<li>
									<MpText>
										Evaluation of the possibility of pre-setting templates and automatic product
										start.
									</MpText>
								</li>
								<li>
									<MpText>
										Identifying new issues after real-world use of the feature and incorporating
										them into the roadmap.
									</MpText>
								</li>
							</MpUl>
						</RoadmapItemStyled>
					</RoadmapStyled>
				</DescriptionBlockStyled>
			</section>
			{canPurchaseApps && (
				<SectionStyled>
					<MpTitle level={2}>Commission Costs</MpTitle>
					<MpText style={{ marginBottom: `12px` }}>
						For partners of the &quot;Dodo Pizza&quot; network, personal conditions apply. They may change
						depending on your turnovers. More payments to self-employed—less percentage of commission and
						licensing fees.
					</MpText>
					<SubheadingStyled>
						Licensing fee for connecting one self-employed person per month to EDO:
					</SubheadingStyled>
					<MpUl>
						<li>
							<MpText>
								250 ₽ / month for each performer with whom at least one document, excluding the
								contract, has been signed.
							</MpText>
						</li>
					</MpUl>
					<SubheadingStyled>Commission percentage from payment to self-employed:</SubheadingStyled>
					<MpUl style={{ gap: `unset` }}>
						<li>
							<MpText>
								1%, but not less than 49 ₽, from the amount of payment to the performer to the
								settlement account.
							</MpText>
						</li>
						<li>
							<MpText>
								1%, but not less than 75 ₽, from the amount of payment to the performer by card number.
							</MpText>
						</li>
					</MpUl>
					<MpText>
						Write to us at <MpLink url='mailto:dodo@konsol.pro' text='dodo@konsol.pro' internal /> to learn
						the details and get free demo access to the platform.
					</MpText>
				</SectionStyled>
			)}
		</>
	);
};
